import createStorageHook from"./factory/createStorageHook";/**
 * Save a value on session storage
 */var useSessionStorage=createStorageHook("session");export default useSessionStorage;